import React from 'react';
/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */
import { defineMessages } from 'react-intl-next';

import AvatarGroup from '@atlaskit/avatar-group';
import { Stack } from '@atlaskit/primitives/compiled';
import type { IntlShape } from 'react-intl-next';
import type { User } from '@atlaskit/user-picker';

const i18n = defineMessages({
	publishSuccessMessageWithSpaceName: {
		id: 'editor-features.user.publish.success.with.space.name',
		description: 'Success message containing space name when publishing a page',
		defaultMessage: '{pageTitle} was successfully published in the {spaceName} space',
	},
	publishSuccessMessage: {
		id: 'editor-features.user.publish.success',
		description: 'Success message when publishing a page',
		defaultMessage: '{pageTitle} was successfully published',
	},
	publishSuccessMessageWithSocial: {
		id: 'editor-features.publish.success.message.with.social',
		description: 'Success message when a page is published with collaborator avatar',
		defaultMessage: 'Share this page to ensure your team can see and build on your contributions.',
	},
});

type SuccessFlagDescriptionProps = {
	intl: IntlShape;
	title: string | null;
	spaceName?: string;
	suggestedUsers?: User[] | null;
	showSocial?: boolean;
};

export const SuccessFlagDescription: React.FC<SuccessFlagDescriptionProps> = ({
	intl,
	title,
	spaceName,
	suggestedUsers = [],
	showSocial,
}) => {
	if (showSocial) {
		const avatarGroupData = (suggestedUsers || []).reduce((users: any[], currentUser) => {
			const name = currentUser?.name;
			const picture = currentUser?.avatarUrl;

			if (name) {
				return [
					...users,
					{
						name,
						src: picture || '',
					},
				];
			}
			return users;
		}, []);

		return (
			<Stack space="space.100" alignInline="start">
				<span>{intl.formatMessage(i18n.publishSuccessMessageWithSocial)}</span>
				{avatarGroupData.length > 0 && <AvatarGroup size="small" data={avatarGroupData} />}
			</Stack>
		);
	}

	const defaultMessage = spaceName
		? i18n.publishSuccessMessageWithSpaceName
		: i18n.publishSuccessMessage;
	const messageData = { spaceName, pageTitle: <b>{title}</b> };

	return (
		<Stack space="space.100" alignInline="start">
			<span>{intl.formatMessage(defaultMessage, messageData)}</span>
		</Stack>
	);
};
